import { COVERGO_SAAS_DEV } from "../consts.js"

export const petmga_sandbox = {
	"petmga-sandbox-studio.dev.asia.covergo.cloud": {
		appConfig: {
			tenantId: "petmga_sandbox",
			appId: "covergo_crm"
		},
		envConfig: COVERGO_SAAS_DEV,
		fileSystem: {
			bucketName: "covergo-apse1-dev-petmga-sandbox-dev"
		}
	}
}
